module.exports = __webpack_public_path__ + "img/landing9.6b9afc6b.jpg";